import React, { useEffect } from 'react';
import useUserContext from 'Context/UserContext';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import useCollection from 'Hooks/useCollection';
import history from 'State/history';
import fr from 'facet-rest';
import Typography from 'Components/UI/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import AccountSupportAccordionList from './AccountSupportAccordionList';

const styles = theme => ({
  root: {
    padding: theme.spacing(4),
  },
  headers: {
    display: 'flex',
    flex: '1 1',
  },
  cell: {
    marginTop: 0,
    fontSize: 12,
    textAlign: 'left',
    flexGrow: 1,
    width: '100%',
    maxWidth: '1/6',
    color: theme.palette.primary.main,
  },
  paper: {
    borderRadius: theme.radius.sm,
    margin: theme.spacing(1),
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
});

const AccountSupport = ({ classes }) => {
  const { userResource } = useUserContext();
  const { collection, setCollection } = useCollection();

  async function loadEvents() {
    const currentSearchParams = new URLSearchParams(history.location.search);
    const link = currentSearchParams.get('link');
    try {
      const eventsCollection = await fr.http.get(link);
      setCollection(eventsCollection);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  }

  useEffect(() => {
    loadEvents();
    return () => {
      const currentSearchParams = new URLSearchParams(history.location.search);
      currentSearchParams.delete('link');
    };
  }, []);


  if (!(userResource && collection)) {
    return <LoadingIndicator />;
  }

  return (
    <div className={classes.root}>
      <div className={classes.headers}>
        <Typography className={classes.cell}>
          {'Last Session'}
        </Typography>
        <Typography className={classes.cell}>
          {'Institution'}
        </Typography>
        <Typography className={classes.cell}>
          {'Source'}
        </Typography>
        <Typography className={classes.cell}>
          {'Error Code'}
        </Typography>
        <Typography className={classes.cell}>
          {'Error Message'}
        </Typography>
        <Typography className={classes.cell}>
          {'Support'}
        </Typography>
      </div>
      <AccountSupportAccordionList collection={collection} />
    </div>
  );
};

AccountSupport.defaultProps = {
};

AccountSupport.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default withStyles(styles)(AccountSupport);
